import { useContext } from 'react';
import { ParticipantMenuContext } from '../../components/video/ParticipantMenu/ParticipantMenuProvider';

export default function useParticipantMenuContext() {
  const context = useContext(ParticipantMenuContext);
  if (!context) {
    throw new Error('useParticipantMenuContext must be used within a ParticipantMenuProvider');
  }
  return context;
}
